export const GET_PRODUCTION_PLAN_TAB_METADATA =
  'GET_PRODUCTION_PLAN_TAB_METADATA';
export const GET_PRODUCTION_PLAN_TAB_METADATA_SUCCESS =
  'GET_PRODUCTION_PLAN_TAB_METADATA_SUCCESS';
export const SET_PRODUCTION_PLAN_UPDATED_AT = 'SET_PRODUCTION_PLAN_UPDATED_AT';
export const GET_INVENTORY_STATUS_DATA = 'GET_INVENTORY_STATUS_DATA';
export const GET_INVENTORY_STATUS_DATA_COMPLETE =
  'GET_INVENTORY_STATUS_DATA_COMPLETE';
